import { DocumentUrl, FilterNotice } from "./cartable.model";

export interface BasicNoticeResponse {
  noticeKey: string;
  noticeType: string;
  creationDate: Date;
  creationDatePersian: string;
  title: string;
  noticeUserCount: number;
  canEdit: boolean;
  noticeTypePersian: string;
  creatorFullName: string;
}

export enum NoticeTypeEnum {
  Instant = "آنی",
  Information = "اطلاع رسانی",
}

export interface NoticeItemRequest {
  noticeType: string;
  noticeKey: string;
  title: string;
  body: string;
  canSendSms: boolean;
  expirationDate: Date | undefined;
  supplierIdList: number[];
  creationDate: Date;
  creationDatePersian: string;
  NoticeUserCount: number;
  canEdit: boolean;
}

export interface NoticeItemRequest {
  noticeType: string;
  title: string;
  body: string;
  canSendSms: boolean;
  expirationDate: Date | undefined;
  supplierIdList: number[];
  attachments: DocumentUrl[];
  supplierIds: number[];
  smsData: string | undefined;
}


export interface NoticeItemResponse {
  isSuccess: boolean;
  attachments: DocumentUrl[];
}
export interface NoticeItemRequest {
  noticeType: string;
  title: string;
  body: string;
  rawBody: string;
  canSendSms: boolean;
  expirationDate: Date | undefined;
  supplierIdList: number[];
  creationDate: Date;
  creationDatePersian: string;
  NoticeUserCount: number;
  canEdit: boolean;
  showInLoginPage: boolean;
}


export interface NoticeItemRequest {
  noticeType: string;
  title: string;
  body: string;
  rawBody: string;
  canSendSms: boolean;
  showInLoginPage: boolean;
  expirationDate: Date | undefined;
  supplierIdList: number[];
  attachments: DocumentUrl[];
  supplierIds: number[];
  smsData: string | undefined;
}

export interface NoticeItemResponse {
  isSuccess: boolean;
  attachments: DocumentUrl[];
}

export interface UpdateNoticeItemRequest {
  noticeKey: string;
  noticeType: string;
  title: string;
  body: string;
  rawBody: string;
  canSendSms: boolean;
  expirationDate: Date | undefined;
  supplierIdList: number[];
  showInLoginPage: boolean;
}

export interface ShowItemRequest {
  noticeKey: string;
  isVisited: boolean | undefined;
}

export interface NoticeItemDetail {
  noticeKey: string;
  noticeType: string;
  noticeTypePersian: string;
  title: string;
  body: string;
  rawBody: string;
  creationDate: Date;
  creationDatePersian: string;
  canSendSms: boolean;
  showInLoginPage: boolean;
  expirationDate: Date | undefined;
  expirationDatePersian: string;
  supplierIdList: number[];
  attachments: DocumentUrl[];

}

export class GetSupplierNoticesRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}

export class Filter {
  noticeType: string[] | undefined;
  title?: string | undefined;
}

export interface DeleteAttachmentRequest {
  fileId: string;
}

export interface AddAttachmentRequest {
  noticeKey: string;
  files: Files[];
  // files: DocumentUrl[];
}

export class Files {
  file: File | undefined;
  documentType: string | undefined;
}

export class GetAllSuppliersInfoRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: ShowItemRequest | undefined;
}

export class GetAllSuppliersInfoResponse {
  fullName: string | undefined;
  supplierName: string | undefined;
  mobileNumber: string | undefined;
  viewDate: Date | undefined;
  viewDatePersian: string | undefined;
  visit: boolean | undefined;
}